import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFOcclusion = {};

export const IBF_OCCLUSION = {
  value: 0x40000,
  name: "IBF_OCCLUSION",
  size: 0,
  parse: (): IBFOcclusion => {
    return {};
  },
} satisfies IBFHistoryRecordDefinition<IBFOcclusion>;
